"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BadgePage = BadgePage;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("@iconify/react");
var react_3 = require("react");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var letsachieve_1 = require("../../../../../api/letsachieve");
var pageHeader_1 = require("../../../../../components/pageHeader");
var console_1 = require("../../../../../reducers/slices/console");
var item_detail_layout_1 = require("../components/item_detail_layout");
var constants_1 = require("../constants");
var badge_settings_1 = require("./components/badge_settings");
function BadgePage() {
    var item_id = (0, react_router_dom_1.useParams)().item_id;
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _a = (0, react_3.useState)(null), actionsContainer = _a[0], setActionsContainer = _a[1];
    var _b = (0, letsachieve_1.useGetItemQuery)(item_id !== null && item_id !== void 0 ? item_id : "", { skip: !item_id }), badge = _b.data, isLoading = _b.isLoading, isError = _b.isError;
    (0, react_3.useEffect)(function () {
        var _a;
        if (!item_id) {
            dispatch((0, console_1.setPageTitle)("Create Badge"));
            return;
        }
        dispatch((0, console_1.setPageTitle)((_a = badge === null || badge === void 0 ? void 0 : badge.name) !== null && _a !== void 0 ? _a : "Badge"));
    }, [item_id, badge, dispatch]);
    var back = { label: "Back to items", on_press: function () { return navigate((0, constants_1.itemsListPath)()); } };
    if (!item_id) {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-4 max-w-6xl mx-auto w-full", children: [(0, jsx_runtime_1.jsx)(pageHeader_1.PageHeader, { back: back, title: "Create Badge", actions_ref: setActionsContainer }), (0, jsx_runtime_1.jsx)(badge_settings_1.BadgeSettings, { actions_container: actionsContainer })] }));
    }
    if (isLoading)
        return (0, jsx_runtime_1.jsx)(react_1.Spinner, { size: "lg" });
    if (isError || !badge) {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col items-center justify-center gap-4 py-16", children: [(0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "mdi:alert-circle", className: "text-4xl text-danger" }), (0, jsx_runtime_1.jsx)("p", { className: "text-lg font-semibold", children: "This badge could not be loaded." }), (0, jsx_runtime_1.jsx)(pageHeader_1.BackButton, __assign({}, back))] }));
    }
    return ((0, jsx_runtime_1.jsx)(item_detail_layout_1.ItemDetailLayout, { item: badge, back: back, render_settings: function (settingsActionsContainer) { return (0, jsx_runtime_1.jsx)(badge_settings_1.BadgeSettings, { item: badge, actions_container: settingsActionsContainer }); } }));
}
